export default {
  user: {},
  token: null,
  title: '',
  language:'cn',
  level:'-1',
  channel:'',
  crumbs_arr: [], // 面包屑列表
  current_name: '', // 面包屑当前页名称
  area_id: 1, // 区域id
  order_type: {}, // 征信报告订单类型
  org_id: '', // 详情id
  basic_info: {}, // 基本信息
  alipay_html: '', // 支付宝支付跳转
  leader_info: [], // 高管关联信息高管列表
  is_online: '', // 是否在线 5离线 4在线
  country_code: '', // 国家简称
  country_name: '', // 国家名称
  unread_msg: 0
}



// WEBPACK FOOTER //
// ./src/store/state.js